import { createSelector } from 'reselect';

export const selectClasses = createSelector(
  state => state.golfSchools.classes,
  classes => (classes.get('data') ? classes.toJS() : null)
);

export const selectActiveGolfSchool = createSelector(
  [(state, id) => state.golfSchools.schools, (state, id) => id],
  (schools, id) => {
    if (schools.get('loaded') && id) {
      const activeGolfSchool = schools.get('data').find(school => school.get('id') === parseInt(id, 10));

      return activeGolfSchool ? activeGolfSchool.toJS() : null;
    }
    return null;
  }
);

export const selectActiveClass = createSelector(
  (state, classId) => state.golfSchools.classes,
  (state, classId) => classId,
  (classes, classId) => {
    if (classes.get('loaded') && classId) {
      const activeClass = classes.getIn(['data', 'results']).find(item => item.get('id') === parseInt(classId, 10));
      return activeClass ? activeClass.toJS() : null;
    }
    return null;
  }
);



// WEBPACK FOOTER //
// ./src/golf-schools/selectors.js